import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import AccountActivitiesTable from './AccountActivitiesTable';
import ButtonSecondary from '../ButtonSecondary';
import activityIcon from '../../img/icons/activities.svg';
import style from '../../style/components/signin/AccountActivities.module.scss';
import Card from '../Card';

const AccountActivities = ({
  activeTab,
  activities,
  complete,
  handleLoadMore,
  handleTabChange,
  isFetching,
}) => {
  const { t } = useTranslation();

  const tabs = [
    { key: '*', name: t('activity.tab_all') },
    { key: 'signin', name: t('activity.tab_signins') },
    { key: 'connection', name: t('activity.tab_connect') },
    { key: 'disconnect', name: t('activity.tab_disconnect') },
    { key: 'verification', name: t('activity.tab_verifications') },
  ];

  return (
    <Card
      className={style.card}
      title={t('activity.title')}
      icon={<img alt="activities" src={activityIcon} />}
    >
      <div className={style.tabs}>
        {tabs.map((tab) => (
          <button
            key={tab.key}
            type="button"
            onClick={() => handleTabChange(tab)}
            className={activeTab.key === tab.key ? style.active : ''}
          >
            {tab.name}
          </button>
        ))}
      </div>
      <AccountActivitiesTable
        activities={activities}
        activeTab={activeTab}
        isFetching={isFetching}
      />
      {complete && activities.length > 0 && (
        <p>{t('activity.description_complete')}</p>
      )}
      {!complete && !isFetching && (
        <ButtonSecondary onClick={handleLoadMore} disabled={isFetching}>
          {t('activity.button_loadMore')}
        </ButtonSecondary>
      )}
    </Card>
  );
};

AccountActivities.propTypes = {
  activeTab: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  activities: PropTypes.arrayOf(
    PropTypes.shape({
      authorized: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ).isRequired,
  complete: PropTypes.bool.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  handleTabChange: PropTypes.func.isRequired,
};

export default memo(AccountActivities);
